/* eslint-disable no-param-reassign */
const coupon = function() {
	const $cart = document.querySelector('.js-coupon-cart');

	if (!$cart) {
		// removes remove button from card if it is not a coupon cart
		const $anchors = document.querySelectorAll('.js-coupon-remove');
		$anchors.forEach($anchor => {
			$anchor.remove();
		});
		return;
	}

	const replaceHTML = ($el, htmlString) => {
		$el.innerHTML = htmlString;
	};

	const triggerListeners = function() {
		// eslint-disable-next-line no-undef
		$('#land').trigger('change');
	};

	const removeOnClick = function() {
		const $anchors = document.querySelectorAll('.js-coupon-remove');

		if ($anchors.length === 0) {
			return;
		}

		$anchors.forEach($anchor => {
			const endpoint = $anchor.getAttribute('action');

			if (!endpoint) {
				return;
			}

			$anchor.addEventListener('submit', ev => {
				// Prevent submit so we can submit through API
				ev.preventDefault();

				window
					.POSTBARE(endpoint, new FormData($anchor))
					.then(data => {
						try {
							const json = JSON.parse(data.response);
							if (json.Success) {
								if (json.HTML && $cart) {
									replaceHTML($cart, json.HTML);
									removeOnClick();
									triggerListeners();
								}
							}
						} catch (e) {
							// eslint-disable-next-line no-console
							console.error(e, data);
						}
					})
					.catch(response => {
						// eslint-disable-next-line no-console
						console.error(response);
					});
			});
		});
	};

	const addOnSubmit = function() {
		const $forms = document.querySelectorAll('.js-coupon-add');

		if ($forms.length === 0) {
			return;
		}

		const clearMessage = $el => {
			$el.classList.add('is-hidden');
			$el.classList.remove('has-text-success');
			$el.classList.remove('has-text-danger');
			$el.querySelector('.js-coupon-add-message-text').innerHTML = '';
		};
		const setError = ($el, errorMessage) => {
			$el.querySelector('.js-coupon-add-message-text').innerHTML = errorMessage;
			$el.classList.add('has-text-danger');
			$el.classList.remove('is-hidden');
		};
		const setSuccess = ($el, successMessage) => {
			$el.querySelector('.js-coupon-add-message-text').innerHTML = successMessage;
			$el.classList.add('has-text-success');
			$el.classList.remove('is-hidden');
		};
		const clearInput = $el => {
			$el.value = '';
			// eslint-disable-next-line no-undef
			$($el).trigger('focusout');
		};

		$forms.forEach($form => {
			const endpoint = $form.getAttribute('action');
			const genericError = $form.getAttribute('data-coupon-generic-error');
			const $input = $form.querySelector('.js-coupon-add-input');
			const $message = $form.querySelector('.js-coupon-add-message');

			if (!endpoint || !genericError || !$input || !$message) {
				return;
			}

			$form.addEventListener('submit', ev => {
				// Prevent submit so we can submit through API
				ev.preventDefault();
				// Don't continue if not valid
				if (!ev.target.checkValidity()) {
					return;
				}
				// Remove our previous message if any
				clearMessage($message);
				// Don't continue if couponcode is not inputted (Purposefully not done through the required validation, because customer doesn't want required validation)
				if ($input.value.length === 0) {
					return;
				}

				window
					.POSTBARE(endpoint, new FormData($form))
					.then(data => {
						try {
							const json = JSON.parse(data.response);
							if (json.Success) {
								setSuccess($message, json.Message);
								clearInput($input);
								if (json.HTML && $cart) {
									replaceHTML($cart, json.HTML);
									removeOnClick();
									triggerListeners();
								}
							} else {
								setError($message, json.Message);
							}
						} catch (e) {
							// eslint-disable-next-line no-console
							console.error(e, data);
							setError($message, genericError);
						}
					})
					.catch(response => {
						// eslint-disable-next-line no-console
						console.error(response);
						setError($message, genericError);
					});
			});
		});
	};

	addOnSubmit();
	removeOnClick();
};

module.exports = coupon;
